// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLaborRateCount} from '../../shared/repositories';

export const readLaborRateCount = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborRateCount();

            dispatch({
                data,
                type: actions.SET_LABOR_RATE_COUNT
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/action-creators/read-labor-rate-count.js